import type { Job } from '@kanda-libs/ks-frontend-services';
import { useMemo } from 'react';
import { calculateJobTotal } from 'utils';
import { checkJobPaidByOB } from 'utils/Job-functions';

export interface OpenBankingInfoHook {
  subsidy: number;
  example: number;
  showInvalid: boolean;
  isPaid: boolean;
}

export default function useOpenBankingInfo(job?: Job): OpenBankingInfoHook {
  const lineItems = useMemo(() => job?.job_items, [job]);

  const total = useMemo(() => {
    if (!lineItems) return 0;
    const totals = calculateJobTotal(lineItems);
    return totals.totalIncVat;
  }, [lineItems]);

  const isPaid = useMemo(() => checkJobPaidByOB(job), [job]);

  const subsidy = useMemo(() => total * 0.01, [total]);

  const example = useMemo(() => total * 0.016, [total]);

  const showInvalid = useMemo(() => total > 1000000, [total]);

  return {
    subsidy,
    example,
    showInvalid,
    isPaid,
  };
}
